import { render, staticRenderFns } from "./CustomUploader.vue?vue&type=template&id=b1d36202&scoped=true&"
import script from "./CustomUploader.vue?vue&type=script&lang=js&"
export * from "./CustomUploader.vue?vue&type=script&lang=js&"
import style0 from "./CustomUploader.vue?vue&type=style&index=0&id=b1d36202&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d36202",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VFileInput,VRow})
